import React from 'react';
import propTypes from 'prop-types';
import _ from 'lodash';
import { Stack, IconButton, Tooltip, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { FieldArray, useField } from 'formik';
import Expresion, { defaultValue as Edefault, schema as Eschema } from './Expression';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

export const schema = Yup.array().of(Eschema).min(1, 'A least one expression is required');
export const defaultValue = [{ ...Edefault }];

export default function ExpressionsList({ namespace, simplified = false, ...props }) {
  const { t } = useTranslation();
  const [field] = useField(namespace);
  const expressions = field.value;

  return (
    <FieldArray
      name={namespace}
      render={({ push, remove }) => (
        <Stack spacing={2} direction='column'>
          {simplified && (
            <Typography variant='body2' color='text.secondary'>
              {t('MOVE_CONF.EXPRESSION_HELP')}
            </Typography>
          )}
          {_.map(expressions, (exp, i) => (
            <Expresion
              {...props}
              key={i}
              namespace={namespace + `.${i}`}
              onRemove={simplified ? undefined : () => remove(i)}
              showName={!simplified}
            />
          ))}
          {!simplified && (
            <Stack flexGrow={1} direction='row' alignItems='center' justifyContent='center'>
              <Tooltip title='Add an expression' open={expressions.length === 0}>
                <IconButton onClick={() => push(Object.assign({}, Edefault))}>
                  <AddIcon />
                </IconButton>
              </Tooltip>
            </Stack>
          )}
        </Stack>
      )}
    />
  );
}

ExpressionsList.propTypes = {
  namespace: propTypes.string,
}